import createMediaApi from '~/App/Api/Media';

type UseUploadImageMediaArgs = {
  formData: FormData;
  onUploadProgress: (progress: number) => void;
};
export const useUploadImageMedia = async ({
  formData,
  onUploadProgress,
}: UseUploadImageMediaArgs) => {
  const mediaApi = createMediaApi();
  const image = formData.get('file') as File;

  return mediaApi.post(formData, {
    onUploadProgress(evt) {
      onUploadProgress(Math.floor((evt.loaded / image.size) * 100));
    },
  });
};
